import { JsonStringHelper } from "../../../../common/utils/JsonStringHelper";
import { useMemo } from "react";

/**
 * A log's description, always as text (React escapes it): descriptions come from anonymous ingest, so they are
 * attacker-controlled. JSON descriptions are pretty-printed; <pre> + the page's pre-wrap keep the line breaks.
 */
export function LogDescription(props: { description?: string | null }) {
    const text = useMemo(() => {
        const d = props.description;
        if (d === undefined || d === null || d === "") return "No description provided.";
        return JsonStringHelper.FormatString(d);
    }, [props.description]);

    return <pre id="description" className="log-description">{text}</pre>;
}
